import React from "react";
import { ErrorIcon } from "../../assets/icon";

import s from "./FormTextaria.module.scss";

function FormTextarea({ ...props }) {
  const { errors, register, name, label, subLabelButton } = props;

  return (
    <div className={s.form_group}>
      {label && (
        <label className={s.label} htmlFor={name}>
          {label}
        </label>
      )}
      <div className={s.input_box}>
        <textarea
          className={!!errors && errors[name] ? `${s.is_invalid}` : ``}
          name={name}
          ref={!!register ? register : null}
          type={name}
          id={name}
          rows="5"
        />
        <div className={s.error_icon}>
          {!!errors && errors[name]?.message && <ErrorIcon />}
        </div>
      </div>
      {subLabelButton && (
        <label className={s.subLabelButton} htmlFor={name}>
          {subLabelButton}
        </label>
      )}

      <div className={s.error}>{!!errors && errors[name]?.message}</div>
    </div>
  );
}

export default FormTextarea;
